export const STATISTICS_WITH_MINUTES_SIGN: string[] = ['minutes', 'minutes_substitute'];
export const STATISTICS_WITH_PERCENTAGE_SIGN: string[] = ['possession'];
export const MINUTES_SIGN = "'";
export const PERCENTAGE_SIGN = '%';

export const NEGATIVE_STATS = [
  'fouls_committed',
  'offsides',
  'penalties_committed',
  'penalties_missed',
  'red_cards',
  'substitute_out',
  'yellow_cards',
  'draws',
  'defeats',
  'goalsConceded',
  'rank',
];

export const PLAYER_H2H_STATISTICS = [
  'assists',
  'cleansheets',
  'fouls_committed',
  'goals',
  'goals_substitute',
  'minutes',
  'minutes_substitute',
  'offsides',
  'own_goals',
  'penalties_committed',
  'penalties_missed',
  'penalties_received',
  'penalties_saved',
  'penalty_goals',
  'played',
  'red_cards',
  'shots',
  'shots_on_target',
  'started',
  'substitute_in',
  'substitute_out',
  'yellow_cards',
];

export const TEAM_H2H_STATISTICS = ['defeats', 'draw', 'goals_conceded', 'goals_scored', 'played', 'win', 'points', 'rank'];
